import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { es, en } from "../locales/index"

i18n.use(initReactI18next).init({
  lng: "es",
  fallbackLng: "es",
  supportedLngs: ["es", "en"],
  ns: ["common", "error", "auth", "votes", "blockchain"],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    es: es,
    en: en,
  },
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i", "span"],
  },
})
